import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios'

//使用vuex
Vue.use(Vuex)

var state={
  ScrollTop:0,
  isBoat:[true,false,false,false,false,false,false,false,false,false,false,false]
}
var mutations={
  //保存滚动条位置
  handleScrollTop(state,payLoad){
     state.ScrollTop=payLoad  
  },
  handleIsBoat(state,payLoad){
    state.isBoat=state.isBoat.map((item,i)=>{
      item=false
      state.isBoat.push(item)
      // console.log(item)
    })
    state.isBoat[payLoad]=true
    console.log(state.isBoat)
  }
  
}

var actions={

}
//创建一个store对象
var store=new Vuex.Store({
    state,
    mutations,
    actions
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js